import type { AddFundsAction } from '@/features/billing-usage';
import type { CreditPurchaseActions } from '../hooks/use-credit-purchase';

/** The Flex Add funds CTA: opens the Flex Add funds modal, gated like every Builder funds purchase. */
export function flexAddFundsAction(purchase: CreditPurchaseActions, hasFunded: boolean): AddFundsAction {
  return {
    onPurchase: () => void purchase.openAddFunds({ hasFunded }),
    isPurchaseDisabled: purchase.builderCredits.isPurchaseDisabled,
    purchaseDisabledMessage: purchase.builderCredits.purchaseDisabledMessage,
  };
}
